import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import styles from "./styles.module.css";

// TODO move to core

export type FlexGapProps = {
	minWidth: string;
	maxWidth: string;
} & Partial<ClassNameProps & StyleProps>;

export function FlexGap({ minWidth, maxWidth, className, style }: FlexGapProps) {
	return <div className={makeClassName(styles["flex-gap"], className)} style={{ minWidth, maxWidth, ...style }}></div>;
}
